import { isEuWireCurrency } from '@b-stock/fe-core/bstock-next/helpers'

/**
 * Currencies whose orders are paid by bank wire only, so the digital-payment
 * UI (saved methods, ACH / card / Net Terms copy, Pay Now) must not render:
 * CAD (hardcoded checkout card) and the EU wire currencies (bank account
 * resolved by the order service).
 */
export const isWireOnlyCurrency = (
  currencyCode: string | null | undefined
): boolean =>
  currencyCode?.toUpperCase() === 'CAD' || isEuWireCurrency(currencyCode)
